// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ItemDetail } from './item-detail';
import { PoDetail } from './po-detail';
import { PoDetailCancel } from './po-detail-cancel';
import { PoNote } from './po-note';
import { PoTrxHist } from './po-trx-hist';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PoTrx extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** DateTimeOffset */
  crtnTs!: Date;
  /** String(255) */
  note?: string;
  /** Int32 */
  podCount!: number;
  /** Inv FK poTrxId */
  itemDetails!: ItemDetail[];
  /** Inv FK poTrxId */
  poDetailCancels!: PoDetailCancel[];
  /** Inv FK poTrxId */
  poDetails!: PoDetail[];
  /** Inv FK poTrxId */
  poNotes!: PoNote[];
  /** Inv FK poTrxId */
  poTrxHists!: PoTrxHist[];
}

